import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "isDark", "title"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["appearance", "density", "className", "elevate", "intent", "isScrollable", "isFullHeight"];
import * as React from 'react';
import cn from 'classnames';
import { clamp } from 'lodash-es';
import { elevateClass, Enum, intentClass } from '../../../library/index';
import { Pane } from '../../pane';
var boxClasses = {
  MAIN: 'box',
  BODY: 'box__body',
  HEADER: 'box__header',
  TITLE: 'box__title',
  FOOTER: 'box__footer'
};
export var BoxHeader = function BoxHeader(props) {
  var className = props.className,
    children = props.children,
    isDark = props.isDark,
    title = props.title,
    paneProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(boxClasses.HEADER, {
    '-dark': isDark
  }, className);
  return React.createElement(Pane, _extends({
    className: classNames
  }, paneProps), !title || !!children ? null : React.createElement("div", {
    className: boxClasses.TITLE
  }, title), children);
};
BoxHeader.displayName = 'BoxHeader';
BoxHeader.defaultProps = {
  isDark: false
};
export var BoxBody = function BoxBody(props) {
  var className = props.className,
    paneProps = _objectWithoutProperties(props, _excluded2);
  var classNames = cn(boxClasses.BODY, className);
  return React.createElement(Pane, _extends({
    className: classNames
  }, paneProps));
};
BoxBody.displayName = 'BoxBody';
export var BoxFooter = function BoxFooter(props) {
  var className = props.className,
    paneProps = _objectWithoutProperties(props, _excluded3);
  var classNames = cn(boxClasses.FOOTER, className);
  return React.createElement(Pane, _extends({
    className: classNames
  }, paneProps));
};
BoxFooter.displayName = 'BoxFooter';
export var BoxAppearanceType = Enum({
  MINIMAL: 'minimal',
  OUTLINE: 'outline',
  FILL: 'fill'
});
export var Box = function Box(props) {
  var appearance = props.appearance,
    density = props.density,
    className = props.className,
    elevate = props.elevate,
    intent = props.intent,
    isScrollable = props.isScrollable,
    isFullHeight = props.isFullHeight,
    paneProps = _objectWithoutProperties(props, _excluded4);
  var classNames = cn(boxClasses.MAIN, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "-".concat(props.density), props.density), "-".concat(props.appearance), props.appearance), '-scrollable', props.isScrollable), '-fullheight', props.isFullHeight), intentClass(props.intent), elevateClass(clamp(props.elevate, 4)), props.className);
  return React.createElement(Pane, _extends({
    className: classNames
  }, paneProps));
};
Box.displayName = 'Box';
Box.defaultProps = {
  appearance: BoxAppearanceType.OUTLINE,
  elevate: 0
};
Box.Header = BoxHeader;
Box.Body = BoxBody;
Box.Footer = BoxFooter;